$(document).ready(function(){

	$bingo = ""
	if( document.querySelector("meta[name=rsg_action]") == null ) {
		action ="tbc"
		controller = "tbc"	
	} else {
		action =  document.querySelector("meta[name=rsg_action]").content  
		controller =  document.querySelector("meta[name=rsg_controller]").content
	}	
	
	action_controller = action + "_" + controller

	 window.makeMenuClicks(); 	  

	 if (['edit_deck' ].includes( action_controller ) ) {
		window.docLoadDeck();
	 }


 	$("#contents-images").sortable({
 	 	handle: ".handle",
		cancel: ".ignore", 
		update: function(e, ui) {
 
 		 $these = $(".image-index")
		 
		 $.each( $these , function( index, element ){
			 //element.innerText = index ;
			 if ( element.innerText.includes("Card Back")) {
			 	//nothing
			 } else {
			 	element.innerText = index ;
			 }
		 });
		 		 
		 $url = $(this).data("url")
		 //alert( $url )
		 
 	   $.ajax({
 	     url: $url,
 	     type: "PATCH",
 	     data: $(this).sortable('serialize'),
 	   });

 	 }
 	});
 
   $(".done-scrolling").click(function() {
		$section = this.dataset.section
		
		doneWrap( $section )
	});
	
	$("#contents").sortable({
	 handle: '.handle',
	 update: function(e, ui) {
 		 
 
	   $.ajax({
	     url: $(this).data("url"),
	     type: "PATCH",
	     data: $(this).sortable('serialize'),
	   });

	 }
	});
		 
	

 
	
	
	$("#sortable-yes, #sortable-no").sortable({
		 connectWith: ".connectedSortable", 
	 handle: '.handle',
	 update: function(e, ui) {
		 
		 $these = $(".sortable-yes .handle ").children()
		 console	.log( $these.length )
		 
		 $.each( $these , function( index, element ){
		  	   element.classList.remove("genre_out");
		  		element.classList.add("genre_in");
		 });
		 
		 $these = $(".sortable-no .handle ").children()
		 console	.log( $these.length )
		 
		 $.each( $these , function( index, element ){
		  	   element.classList.remove("genre_in");
		  		element.classList.add("genre_out");
		 });
		 
		 
	   $.ajax({
	     url: $(this).data("url"),
	     type: "PATCH",
	     data: $(this).sortable('serialize'),
	   });

	 }
	});
	
	
	$("#contents-addendum").sortable({
	 handle: '.handle',
	 update: function(e, ui) {
 		 
  	   $.ajax({
  	     url: $(this).data("url"),
  	     type: "PATCH",
  	     data: $(this).sortable('serialize'),
  	   });
 
		//saveAddend()
	 }
	});
	
	//console.log( "Loaded Action Specifc JS: " + action_controller  ); 
	clickWrap();
	scrollWrap();

	// importing images for decks (cards)
	if( $("#my-dropzone").length > 0 ) {
		makeDropzone()
	}
	
	// changing colors for box.
	$("#color").change(function () {	
		changeColor( $("#color").val() ) 
	});	
	
	$(".customizer").change(function () {	
		customEmbed()
	});	
	
	$("#color_background").change(function () {	
		memeColor( $("#color_background" ).val() , "background" ) 
	});	
	$("#color_inner").change(function () {	
		memeColor( $("#color_inner" ).val() , "inner" ) 
	});	
	
	$("#color_border").change(function () {	
		memeColor( $("#color_border" ).val() , "border" ) 
	});
	
	// editing spreads
	$(".question_copy").change(function () {		
		changeQuestion( 0 )
	});
	
	if( $("#make_spread").length > 0 ) {
		
		if ( $("#spread_attached").val() == 'false' ) {
		
			window.saveSpread( 0 )
			
		}
	}	 
	
	
	if( $(".addendum_copy").length > 0 ) {
		makeAddendum()
	}	 
	
	if( $(".datepicker").length > 0 ) {
		datepicker()
	}	 
	
	if( $(".save-deck-info").length > 0 ) {
		saveDeckInfos()
	}	 	
	
	if( $("#send_invites").length > 0 ) {
		readyInvite()
	}	 	
	
   window.spinners()

});


function customEmbed() { 
	
	inner_data = new FormData();
	
	
	for (var k in $(".customizer")) {
		
		inner_data.append( "custom[" + $(".customizer")[k].id + "]" , $(".customizer")[k].value );

	}
	//console.log( inner_data )
	save_url = 	save_url = "/embeds/" + $("#model").val() + "/" + $("#model_id").val() + "/customize" ;
	
	$.ajax({
	 type: "POST",
	 headers: {
	  'X-CSRF-Token': document.querySelector("meta[name=csrf-token]").content ,			 
	 }	,	
 	 enctype: 'multipart/form-data',
 	 processData: false,  // Important!
      contentType: false,
      cache: false,
      timeout: 600000,	
	 url: save_url,
	 data: inner_data,
	 success: function(data){

	 }
		
	})

	 		
}
	
function saveSpread( indexNo = 0 ) {

	save_url = "/layouts/" + $("#spread_id").val() + "/save_spread_image";
	console.log( save_url )

	dataURL = $card_stage[ indexNo ].toDataURL();
	
	inner_data = new FormData();

  	inner_data.append("data[spread]" , dataURL );
	
    //for (let iii = 1; iii <= ( $cards.length + 1 ); iii++) {
  	
	// stub= "data[thumbs]["+  ( iii - 1 ) + "]"
		
	//	dataURL = $card_stage[ iii ].toDataURL();
	//  	inner_data.append( stub , dataURL );
	
    //}
	
	 
	$.ajax({
	 type: "POST",
	 headers: {
	  'X-CSRF-Token': document.querySelector("meta[name=csrf-token]").content ,			 
	 }	,	
 	 enctype: 'multipart/form-data',
 	 processData: false,  // Important!
      contentType: false,
      cache: false,
      timeout: 600000,	
	 url: save_url,
	 data: inner_data,
	 success: function(data){

	 }
		
})

}

function saveDeckInfos( ) {

		save_url = "/decks/" + $("#deck_id").val() + "/save_deck_infos";
		
		console.log( save_url )

		dataURL_0 = $stage[ 0 ].toDataURL();
		dataURL_1 = $stage[ 1 ].toDataURL();

		inner_data = new FormData();
	
	 	inner_data.append( "deckinfo[0]" , dataURL_0 );
	 	inner_data.append( "deckinfo[1]" , dataURL_1 );

		$.ajax({
		 type: "POST",
		 headers: {
		  'X-CSRF-Token': document.querySelector("meta[name=csrf-token]").content ,			 
		 }	,	
    	 enctype: 'multipart/form-data',
    	 processData: false,  // Important!
         contentType: false,
         cache: false,
         timeout: 600000,	
		 url: save_url,
		 data: inner_data,
		 success: function(data){

		 }
		 
		
	
		})

	}
	

function makeAddendum() {
	$(".addendum_copy").change(function () {		
		saveAddend()
	}); 
	
}

function datepicker() {
	$('.datepicker').datepicker({
	format: 'yyyy-mm-dd'
	});
};

function makeDropzone() {

  AUTH_TOKEN=$('meta[name="csrf-token"]').attr('content');
  myfilenames = []
  $url = "/decks/" + $("#deck_id").val() + $("#card_routes").val()
  $batch_size = $("#batch_size").val()
  $file_types= $("#file_types").val()
  $replace= $("#replace_id").val()
  
  uploader = document.querySelector('#my-dropzone');
  
  Dropzone.autoDiscover = false;
  
//	
   //acceptedFiles: "image/jpeg, image/png, image/gif, image/jpg,  image/webp", 

  dropzoneOptions = {
    url: $url ,
    autoProcessQueue: true,
    uploadMultiple: true,
    addRemoveLinks:true,
    acceptedFiles: $file_types, 
	  accept: function(file, done) {
		  
	        if ( $guest_list.length > 0 && !
				  $guest_list.includes( file.name.toLowerCase() ) ) {
	          done("Naha, you don't.");
	        }
	        else { done(); }
	      },
	success: function (file, response) {
		$( "#" + $replace ).html("")
		$( "#" + $replace ).html( response );
		
			
			new_url = "/getfooter/"+ $("#deck_id").val()  + "/decks/import_cards?format=js"
			
			// $(".dz-clickable").html("Upload Complete")
			// show card count > from import
			// update count > Link to upload if > 0  
			
			window.makeMenuClicks();    
			
		  	$.ajax({
		   		  type: "GET",
		   			headers: {
		   			  'X-CSRF-Token': document.querySelector("meta[name=csrf-token]").content
		   			},
		   		  url: new_url,
		   	});
				
	         // var imgName = response;
	         // file.previewElement.classList.add("dz-success");
	         // console.log("Successfully uploaded :" + imgName);

	},
    parallelUploads: $batch_size ,
    params:{
      'authenticity_token':  AUTH_TOKEN
    }
  };

  myDropzone = new Dropzone( uploader , dropzoneOptions ) 

	myDropzone.on("removedfile", function(file) {
	makeFileNames()
	});

	
	myDropzone.on("error", function(file) {
	
	var type = file.type;
				
  	 if (!file.accepted) { 
       if ( $guest_list.length > 0 && !$guest_list.includes( file.name.toLowerCase() ) ) {
		
			 div = document.createElement('div');
			 div.classList=["col-3 text-danger"]
			 div.innerText=file.name
			 
			 invalidfiles.appendChild( div ) 
			 invalidouter.classList = ["row mb-6 mx-1 dropzone invalid-files"]
			 invalidfiles.classList = ["row"]
			 //alert( "This file is not list in your CSV: '" + file.name +  "'\n\nCorrect your spreadsheet and re-upload the CSV or rename file correctly if it is required/valid. \n\nNote: filenames are case sensitive and require extensions. \n \nBeware double spaces. They can be hard to spot.");
		 
		
		 } else {
		 
		 	alert("Invalid file type: " + type + " \n  \nExpecting: " + $("#expecting").val() );
	 	 
		 }
  		 this.removeFile(file) 
  	 }
	 
	});

	
  	myDropzone.on("addedfile", function(file) {
    /* Maybe display some more file information on your page */
	  
		  $these = $(".missing")
		  $.each( $these , function( index, value ){
    	  	    if ( value.dataset.filename == file.name ) {
    	  	    	$(".missing-" + value.dataset.index ).remove()
    	  	    } 
		  });
		  
  
	  if ( myfilenames.indexOf( file.name ) > -1 ) {
		  
	  	myDropzone.removeFile( file ) 
  	  }
	  makeFileNames()
	  
  	} );

 }  
 
function makeFileNames() {
 
 myfilenames = []
 myDropzone.files.forEach( function(one_file, index) {
     myfilenames[ myfilenames.length ] = one_file.name
 })

}   

function doneWrap( section ) {
	
   $("#agreement").removeAttr("disabled")
   $("#checkSpan").addClass("highlight");
		  
   $("#submit").addClass("btn-primary");
   $("#submit").addClass("text-white");
	
	$( "#section-" + section ).removeClass("disabled")
	$( ".list-group-item-action" ).removeClass("active")
	
	$( "#section-" + section ).addClass("active")
   
}
 
function scrollWrap() {
	
	zoom = (( window.outerWidth - 10 ) / window.innerWidth) * 100;
	//console.log( zoom )
	if ( zoom > 115 ) {
		//alert("Zoom is too big. Please set zoom from 0.9% to 1.15%")
	}
	
	if ( zoom < 85 ) {
		//alert("Zoom is too small. Please set zoom from 0.9% to 1.15%")	
	}
	
   last_section = $("#max-section").val();
	
	last_section_but = 	last_section -1
	lastElementSelector = '#list-item-'+ last_section;	
	lastElementSelectortBut = '#list-item-'+ last_section;
	
	$(window).on('activate.bs.scrollspy', function (event, active) {
	    // If the activated element is the last one, do the necessary things
		active = $(".list-group-item.active").attr("href")
		//alert(active)
		section = "#section-"+ active.split("-")[ active.split("-").length -1 ]
      $( section ).removeClass("disabled");
		
	    if (active === lastElementSelector || active === lastElementSelectortBut ) {
	        // Destroy Scrollspy functionality
			
	     doneWrap( section )
	      
	    }
	});
	
}

function spinners() {
	
    $("input[type='number']").inputSpinner()
	
}

function clickWrap() {

  $("#submit").click(function() {
    var tickChecked = $("#agreement").is(":checked");
	
    if (tickChecked) {
      console.log("agree");
	  
	  new_url = "/marketplace/" + $("#user_id").val() + "/agree/" + $("#version").val()
	  	  
	  	$.ajax({
	   		  type: "POST",
	   			headers: {
	   			  'X-CSRF-Token': document.querySelector("meta[name=csrf-token]").content
	   			},
	   		  url: new_url,
	   	});
	
    } else {
		
      $("#pleaseTick").replaceWith(
        "<div class='small-text'>Please tick the checkbox before clicking 'Submit'</div>"
      );
	  
    }
  });
    
} 


(function(window) {

function makeMenuClicks() {
	
	$(".dmy-make-menu").unbind();
	
	$(".dmy-make-menu").click( function () {
		
		this.disabled="true";

			//switched to class on id -> support multiples
			dom_key= ( ".menu-"+ this.dataset.model+ "-" + this.dataset.id ).toLowerCase();
			
			new_class = ( "dmy-menu-"+ this.dataset.model+ "-" + this.dataset.id ).toLowerCase();
			//console.log( this.dataset )
			parent_bonus = ""
			//alert( dom_key + " : " + new_class)

		
		  if ( !(this.dataset.parentid === undefined) ) {
			parent_bonus = "&parent_id=" + this.dataset.parentid + "&parent_class=" + this.dataset.parentmodel
		  }
		  
		 
			if ( this.dataset.nocrud == "true" ) {
				no_crud= true;
			} else {					
				no_crud= false;
			};
								
			if ( this.dataset.loaded == "true" ) {
				//already done;
			} else {
				this.dataset.loaded = "true";
				//this.attr("data-loaded","true");
			
			// get the url and remove the params by splitting also remove "#" which stops url being processed.
			url      = window.location.href.split("?");
			url = url[0].split("#");
			
			list_size= $( dom_key + " > li").length;
		
			//if ( list_size == 1 ) {
				if ( list_size > 0 ) {
			
				tag = $("#tag_as").val();
				//load_date helps calendar do correct_reload
				
				parent_id =  $("#parent_id").val();
				parent_class =  $("#parent_class").val();
				
	 		  if ( !( parent_id === undefined) ) {
				  parent_bonus = "&parent_id=" + parent_id + "&parent_class=" + parent_class
			  }
			  
					//console.log( url[0] );
					new_url = "/getmenu/?model=" + this.dataset.model + "&model_id=" + this.dataset.id + "&as_at=" + $("#as_at").val() + "&load_date=" + $('#load_date').val() + "&tag=" + tag + "&url="+ url[0] + "&no_crud=" + no_crud + "&color=" + this.dataset.color + parent_bonus ; 
					//};
			
					$.get( new_url );
				

				  
			} else {
			};
					
		};
	});

	
};

function getArrayIndex( this_array, this_id) {
	match = null;
	$.each( this_array , function( key, value ) {
		if ( value == this_id ) {
			//console.log( key, value , this_id);
			match = key;
		};
	});
	return match;
};


function toggleModal() {

	if ( $("#editwindow > .modal").length > 0 ) {
	modal_id = $("#editwindow > .modal")[0].id		
	boot_modal = new bootstrap.Modal(document.getElementById( modal_id ))
	boot_modal.toggle()
    } else {
    	//alert("Nothing")
    }
}
function setupNewEdit() {


	toggleModal()
	
	if( $(".datepicker").length > 0 ) {
		datepicker()
	}	 
	
	$(".close-modal").click( function(){
		// if modal is closed on purpose terminate and remove
		endNewEdit();				
			
	});
	if ( $(".modal-backdrop.show").length > 1 ) {
		$(".modal-backdrop.show")[0].remove()
	}
};


function endNewEdit() {

	toggleModal()
	$(".modal-backdrop").remove();
	$("#editwindow").html("");	
	document.body.style.overflow = 'auto'
	
}


function setupInfo() {

	$("#2nd-modal").modal("show");
	$("#2ndmodal").click(function(){			
	    if($('.modal').hasClass('in')) {
	    	$('body').addClass('modal-open');
	    };    
	});

	$(".close-dmy").click( function(){
		$("#2nd-modal").modal("hide");
		
		media_modal = document.getElementById('media_modal' ); 
		
		// brute force reset source // does not error if no iframe
	  $('iframe').attr('src', $('iframe').attr('src'));
		// https://stackoverflow.com/questions/13598423/stop-all-playing-iframe-videos-on-click-a-link-javascript
		
	});
		
};



function readyInvite() {
	
 	//alert("pre")
	
	$("#send_invites").click(function() {
 
 	  //alert("inner")
		save_url = '/community/1/invites?format=js'
		inner_data = new FormData(formElem)
		$.ajax({
		 type: "POST",
		 headers: {
		  'X-CSRF-Token': document.querySelector("meta[name=csrf-token]").content ,				 
		 }	,	
	     	 enctype: 'multipart/form-data',
	     	 processData: false,  // Important!
	       contentType: false,
	       cache: false,
	       timeout: 600000,	
	  		 url: save_url,
			 data: inner_data,
	  		 success: function(data){

			 }
 

	   });   
   });
	 	
	 
}


// http://theflyingdeveloper.com/controller-specific-assets-with-rails-4/
	
	
window.makeMenuClicks = makeMenuClicks
window.setupInfo = setupInfo
window.endNewEdit = endNewEdit
window.setupNewEdit = setupNewEdit
window.toggleModal = toggleModal
window.saveDeckInfos = saveDeckInfos
window.datepicker = datepicker
window.spinners = spinners

window.makeAddendum = makeAddendum
window.readyInvite = readyInvite

window.saveSpread = saveSpread


})(window);

